/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddRoom } from '../models/AddRoom';
import type { Room } from '../models/Room';
import type { RoomOrder } from '../models/RoomOrder';
import type { Rooms } from '../models/Rooms';
import type { RoomsStatus } from '../models/RoomsStatus';
import type { RoomStatus } from '../models/RoomStatus';
import type { RoomStatusCounts } from '../models/RoomStatusCounts';
import { request as __request } from '../core/request';

export class RoomService {

    /**
     * Get a company floor rooms
     * @returns Rooms Company Floor Rooms
     * @throws ApiError
     */
    public static async getFloorRooms({
companyId,
floorId,
}: {
/** The companyId **/
companyId: number,
/** The Floor Id **/
floorId: number,
}): Promise<Rooms> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/floor/${floorId}/room`,
        });
        return result.body;
    }

    /**
     * Add a company floor
     * @returns Room added Company Floor a Room
     * @throws ApiError
     */
    public static async addFloorRoom({
companyId,
floorId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The Floor Id **/
floorId: number,
requestBody: AddRoom,
}): Promise<Room> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/floor/${floorId}/room`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * update a company floor room
     * @returns Room Company Floor Room updated
     * @throws ApiError
     */
    public static async updateFloorRoom({
companyId,
floorId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The Floor Id **/
floorId: number,
requestBody: Room,
}): Promise<Room> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/floor/${floorId}/room`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * delete a company floor room
     * @returns any Company Floor Room deleted successfully
     * @throws ApiError
     */
    public static async deleteFloorRoom({
companyId,
floorId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The Floor Id **/
floorId: number,
requestBody: Room,
}): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/floor/${floorId}/room`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Sort company floor rooms
     * @returns any The company floor rooms have been sorted successfully
     * @throws ApiError
     */
    public static async sortCompanyFloorRooms({
companyId,
floorId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The Floor Id **/
floorId: number,
requestBody: RoomOrder,
}): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/floor/${floorId}/room/sort`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Get a company rooms
     * @returns Rooms Company Rooms
     * @throws ApiError
     */
    public static async getCompanyRooms({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<Rooms> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/room`,
        });
        return result.body;
    }

    /**
     * Get a company rooms status
     * @returns RoomsStatus Company Rooms Status
     * @throws ApiError
     */
    public static async getCompanyRoomsStatus({
companyId,
timezone,
date,
}: {
/** The companyId **/
companyId: number,
timezone: string,
date?: string,
}): Promise<RoomsStatus> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/room/status`,
            query: {
                'timezone': timezone,
                'date': date,
            },
        });
        return result.body;
    }

    /**
     * add a company rooms status
     * @returns RoomStatus Company Rooms Status Add
     * @throws ApiError
     */
    public static async addCompanyRoomStatus({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: RoomStatus,
}): Promise<RoomStatus> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/room/status`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * update a company rooms status
     * @returns RoomStatus Company Rooms Status Update
     * @throws ApiError
     */
    public static async updateCompanyRoomStatus({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: RoomStatus,
}): Promise<RoomStatus> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/room/status`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * archive a company rooms status
     * @returns RoomStatus Company Rooms Status Archive
     * @throws ApiError
     */
    public static async archiveCompanyRoomStatus({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: RoomStatus,
}): Promise<RoomStatus> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/room/status`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Get a company rooms status based count
     * @returns RoomStatusCounts Company Rooms Status based count
     * @throws ApiError
     */
    public static async getCompanyRoomsStatusCount({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<RoomStatusCounts> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/room/status/count`,
        });
        return result.body;
    }

}